/**
 * 卡片配置中心
 * 统一管理各类卡片的数据配置，新增卡片类型只需在此添加配置
 *
 * 使用方式：
 * import { CAR_PURCHASE_CONFIG } from './cardConfigs'
 * <CardPage :config="CAR_PURCHASE_CONFIG" />
 */

import { SPECIAL_MSG_TYPE } from '@/utils/constant'

/**
 * 购车订单进度配置
 */
export const CAR_PURCHASE_CONFIG = {
	// 表单标题
	formTitle: '购车订单进度查询',

	specialMsgType: SPECIAL_MSG_TYPE.CAR_PURCHASE_ORDER,

	// 信息字段配置（显示在卡片上半部分）
	infoFields: [
		{ label: '手机号', key: 'mobile', value: '' },
		{ label: '订单编号', key: 'orderNum', value: '', firstListItem: true },
	],

	// 结果字段配置（显示在卡片下半部分的滑动区域）
	fieldConfigs: [
		{
			label: '订单状态',
			valueKey: 'orderStatus',
			render: function () {
				const color = '#1A1D25'
				return `<span style="font-weight: bold; color: ${color};">${this.value}</span>`
			},
		},
		{
			label: '经销商名称',
			valueKey: 'dealerName',
		},
		{
			label: '经销商电话',
			valueKey: 'dealerPhone',
			render: function () {
				if (!this.value) return ''
				return `<a style="text-decoration: none; color: #2290FD;" href="tel:${this.value}">${this.value}</a>`
			},
		},
	],
    resultTemplates: [],
}
